import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsColumnChooserExamples: DSReactExamples = {
    basic: {
        label: "Basic",
        description: "Column chooser component",
        examples: {
            basic: {
                react: code`
                    function DemoComponent() {
                        const unselectedCols = [
                            { name: "Red Fish", value: "Red" },
                            { name: "Blue Fish", value: "Blue" }
                        ];
                        const selectedCols = [
                            { name: "One Fish", value: "One" },
                            { name: "Two Fish", value: "Two" }
                        ]
                        return (
                            <SpsColumnChooser
                                unselectedColumns={unselectedCols}
                                selectedColumns={selectedCols}
                                onApplyChanges={(selectedColumns) => {console.log(selectedColumns)}}
                            />
                        );
                    }
                `,
            },
        },
    },
};
